import { render } from "./FormLogin.vue?vue&type=template&id=5ba2133e&scoped=true"
import script from "./FormLogin.vue?vue&type=script&lang=js"
export * from "./FormLogin.vue?vue&type=script&lang=js"

import "./FormLogin.vue?vue&type=style&index=0&id=5ba2133e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ba2133e"]])

export default __exports__